import { isKeyIn } from "./is-key-in";

export function createValueAccessor<T extends object>(a: T) {
  return (b: keyof T) => {
    return isKeyIn(b, a) ? a[b] : b
  }
}